import React from "react";
import PropTypes from "prop-types";
import { motion } from "framer-motion";
import styled from "@emotion/styled";

//style rules
import { Sizes, Animation } from "../../styles";

const BlockModal = ({ toggleBlockModal, pageContent }) => {
	return (
		<Overlay
			className="backdrop"
			variants={Animation.modal.overlayVariants}
			initial="hidden"
			animate="visible"
			exit="hidden"
			onClick={() => toggleBlockModal()}
		>
			<Modal
				variants={Animation.modal.modalVariants}
				onClick={(e) => e.stopPropagation()}
				role="dialog"
			>
				<CloseIcon
					icon={mainScript.assetPath + "images/svg/icons/icon-close-green.svg"}
					onClick={() => toggleBlockModal()}
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							toggleBlockModal();
						}
					}}
					autofocus
					aria-label="Close modal"
				/>
				<FlexContainer>
					<section
						className="panel-content-container"
						dangerouslySetInnerHTML={{ __html: pageContent }}
					/>
				</FlexContainer>
			</Modal>
		</Overlay>
	);
};

export default BlockModal;

BlockModal.propTypes = {
	pageContent: PropTypes.object,
	toggleBlockModal: PropTypes.func,
};

const Overlay = styled(motion.div)`
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: #00000050;
	z-index: 1000;
	cursor: pointer;
`;

const Modal = styled(motion.div)`
	position: relative;
	width: calc(100% - 10px);
	height: 90%;
	margin: 3.3rem auto;
	padding: 9rem 3rem;
	background: white;
	cursor: default;
	border-radius: 20px;
	overflow: scroll;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		overflow: scroll;
		padding: 8rem;
		width: unset;
		max-width: ${Sizes.grids.maxWidth};
	}
`;

const FlexContainer = styled.div`
	display: flex;
	gap: 4rem;
	flex-direction: column;
	align-items: center;

	@media only screen and (min-width: ${Sizes.screens.large}) {
		flex-direction: row;
		gap: 8rem;
		align-items: flex-start;
	}
`;

const CloseIcon = styled.button`
	content: "";
	background: url(${(props) => props.icon && props.icon}) no-repeat;
	width: 30px;
	height: 30px;
	margin: 0.4rem 0 0 0.5rem;
	cursor: pointer;
	position: absolute;
	top: 36px;
	right: 36px;
	padding: 0;
	transition: transform 0.3s ease-in-out;

	&::after {
		content: none;
	}

	&:hover,
	&:focus {
		padding-right: 0;
		transition: none;
		transform: scale(1.1);

		&::after {
			content: none;
		}
	}
`;
